export default "__VITE_ASSET__1abbdc84__"